import React, { useState } from "react";
import Button from "./Button";
import { Icon } from "@iconify/react";
import "../css/offcanvas.css";
import { toggleActive } from "../utils/helpers";
import "../css/main-offcanvas.css";
import BurgerLineButton from "../templates/BurgerLineButton";
import MegalodonLinks from "../templates/MegalodonLinks";
import logoFullImg from "../assets/img/logo-full.png";

const MainOffcanvas = ({ head, className, children, props }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div
      {...props}
      className={`main-offcanvas active-handler${isActive ? " active" : ""} ${
        className ? className : ""
      }`}
    >
      <div
        className="main-offcanvas-shade"
        onClick={() => setIsActive((prev) => !prev)}
      />
      <div className="main-offcanvas-header-container">
        {head}
        <BurgerLineButton
          onClick={() => setIsActive((prev) => !prev)}
          isActive={isActive}
          className="main-offcanvas-button"
        />
      </div>
      <div className="main-offcanvas-container-container">
        <div className="main-offcanvas-container">
          <div className="main-offcanvas-body">{children}</div>
        </div>
        <div className="main-offcanvas-footer">
          <div className="contacts">
            <p className="center">
              <a href="mailto:megalodontheisle@gmail.com" className="contact">
                megalodontheisle@gmail.com
              </a>
            </p>
            <MegalodonLinks />
          </div>
          <div className="logo center">
            <img
              src={logoFullImg}
              alt="Logo"
              style={{
                width: "calc(100% / 3)",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainOffcanvas;
